module.exports = __webpack_public_path__ + "img/contact-via-whatSapp.5d589a21.svg";